import defaultAuth from "../../helpers/defaultAuth";
import { AUTH_UPDATE } from "../actions/AuthActions";
/** @description: Temp sync to redux until we remove all redux */
import "../syncToRedux";
var AuthenticationReducer = function (state, action) {
    if (state === void 0) { state = defaultAuth; }
    var _a = action.auth, auth = _a === void 0 ? {} : _a;
    switch (action.type) {
        case AUTH_UPDATE:
            return auth || defaultAuth;
        default:
            return state;
    }
};
export default AuthenticationReducer;
